export default __webpack_public_path__ + "d07523bca1408111af5311b272970477.svg";